import styled from "@emotion/styled";
export const StyledColoredTimerVerticalTabsComponent = styled.div``;
